import { useQuery, UseQueryResult } from 'react-query';
import { useSelector } from 'react-redux';
import { ConfigKey, getEnvVariable } from '@legacy-modules/common/services/EnvironmentConfigurationService';
import { selectTokenId } from '@redux/auth.selectors';
import { isValidCode } from '@legacy-modules/dashboard/utils/ShipmentHistoryUtils';

export type WunschlagerorteEntry = {
  ort: string;
  typ: 'einmalig' | 'dauerhaft';
};

export type WunschlagerorteResponse = {
  barcode: string;
  entries: WunschlagerorteEntry[];
};

const baseHttpUrl = getEnvVariable(ConfigKey.HTTP_API_URL);

export default function useWunschlagerorte(
  barcode: string,
  enabled: boolean = true
): UseQueryResult<WunschlagerorteResponse> {
  const tokenId = useSelector(selectTokenId);

  return useQuery<WunschlagerorteResponse>({
    queryKey: ['wunschlagerorte', barcode],
    queryFn: () =>
      fetch(`${baseHttpUrl}/shipments/${barcode}/wunschlagerorte`, {
        headers: { token: tokenId },
      }).then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      }),
    enabled: enabled && isValidCode(barcode),
  });
}
